import React from 'react'

function ViewMembership({ service, closeModal }) {
    if (!service) return null;
    function formatDateTime(isoString) {
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    }
    const url = 'uploads/'
    const { date, time } = formatDateTime(service?.createdAt);
    const categoryName = service?.categoryId?.name?.toLowerCase();
    const isPremium = categoryName === "premium";
    const isPrime = categoryName === "prime";
     const imageUrl = service?.image
    ? service.image.startsWith('http')
      ? service.image
      : `${process.env.REACT_APP_URL}${service.image}`
    : null;
    return (
        <div className="modal fade viewbox edit-box show d-block" id="manufacturerModal" tabIndex={-1} aria-labelledby="manufacturerModal" aria-hidden="true" >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="manufacturerModal">Details</h5>
                        <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
                    </div>
                    <div className="modal-body px-5">
                        <div className="d-box mt-3 pt-1">

                                 <div className="text-center mb-3">
                {imageUrl ? (
             <img
 src={`${process.env.REACT_APP_URL}${service.image}`}
  alt={service?.name || 'Membership'}
  style={{ width: '150px', height: '150px', objectFit: 'cover', borderRadius: '8px' }}
/>
                ) : (
                  <img
                    src="/img/placeholder-img.png"
                    alt="No image"
                    style={{
                      width: '150px',
                      height: '150px',
                      objectFit: 'cover',
                      borderRadius: '8px',
                      border: '1px solid #ddd',
                    }}
                  />
                )}
              </div>
                            {/* <h3 className="service-heading" style={{ marginBottom: '10px' }}>About</h3> */}
                            <ul className="d-flex list-unstyled justify-content-between">
                                <li><span>Membership Category: </span>{service?.categoryId?.name}</li>
                                <li><span>Name: </span>{service?.name}</li>
                                <li><span>Price: </span>{service?.price}</li>
                                <li><span>Offer Price: </span>{service?.offer_price}</li>
                                <li><span>Self Subscription Bonus: </span>{service?.self_subscription_bonus}</li>
                                <li><span>Refer Subscription Bonus: </span>{service?.referral_subscription_bonus}</li>
                                {/* <li><span>Duration Days: </span>{service?.durationDays}</li> */}
                                {isPrime && (
                                    <li>
                                        <span>Duration Days: </span>{service?.durationDays}
                                    </li>
                                )}
                                {/* <li><span>Max Orders PerDay: </span>{service?.benefits?.maxOrdersPerDay}</li>
                                <li><span>Max Discount PerOrder: </span>{service?.benefits?.maxDiscountPerOrder}</li>
                                <li><span>discountPercent: </span>{service?.benefits?.discountPercent}</li> */}
                                <li><span>Status: </span> {service?.status}</li>
                                <li><span>Date: </span> {formatDateTime(service?.createdAt)}</li>
                                {/* <li><span>End Date: </span> {formatDateTime(service?.endDate)}</li>  */}
                                {isPremium && (
                                    <li>
                                        <span>End Date: </span>{formatDateTime(service?.endDate)}
                                    </li>
                                )}
                                <li><span>Description: </span> {service?.description}</li>
                            </ul>



                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewMembership